import styled from "styled-components"
import {Label as BaseLabel} from "@irati/ui/src/Typography"
import BaseIcon from "@irati/ui/src/Icon"

export const StyledColumn = styled.div`
  align-items: center;
  height: 100%;
  display: flex;
`

export const Label = styled(BaseLabel)`
  text-transform: capitalize;
`

export const Icon = styled(BaseIcon)`
  position: relative;
  top: 3px;
`
